import { addToErrorContext } from "@/modules/error/errorReporting.ts";
import { isInternalEmail, userDataAtom, userIsAdminAtom } from "@/modules/user/userApi.ts";
import { listenAtom } from "@/utils/jotai/listenAtom.ts";
import { mergeLoadedQueries, queryThen } from "@/utils/query/mergeQueries.ts";
import { atom } from "jotai/vanilla";
import { useEffect } from "react";

/** Fields sent to error reporting */
interface UserContext {
    user_id?: number;
    user_is_admin?: boolean;
    user_email?: string | null;
}

const userErrorContextAtom = atom((get) => queryThen(get(userDataAtom), (data): UserContext => ({ user_id: data.id })));

const adminErrorContextAtom = atom((get) =>
    mergeLoadedQueries(
        { user_is_admin: get(userIsAdminAtom), user: get(userDataAtom) },
        ({ user_is_admin, user }): UserContext => {
            const email = user.profile_data.email;
            return {
                user_is_admin,
                // Do not send user e-mails for non-company/internal users (for privacy reasons)
                user_email: user_is_admin || email == null || isInternalEmail(email) ? email : undefined,
            };
        },
    ),
);

/** Load the user profile data and forward it to the error reporting service */
export function UserErrorContext() {
    useEffect(
        () =>
            listenAtom(userErrorContextAtom, ({ data }) => {
                if (data !== undefined) {
                    addToErrorContext(data);
                }
            }),
        [],
    );

    useEffect(
        () =>
            listenAtom(adminErrorContextAtom, ({ data }) => {
                if (data !== undefined) {
                    addToErrorContext(data);
                }
            }),
        [],
    );

    return null;
}
